import visit from 'unist-util-visit';
import stringify from 'nlcst-to-string';

export default function GradeLevel() {
    const minimumWordsPerSentence:number = 4;
    
    let ariScore:number[] = [];

    return transformer
    
    function transformer(tree: any, file: any) {
        visit(tree, 'SentenceNode', gather);
        
        function gather(sentence: any) {
            let wordCount:number = 0;
            let letters:number = 0;
            let counts;

            visit(sentence, 'WordNode', visitor);

            if (wordCount >= minimumWordsPerSentence) {
                counts = {
                sentence: 1,
                word: wordCount,
                character: letters,
                letter: letters
                };

                ariScore.push(ari(counts));
            };

            return visit.SKIP

            function visitor(node: any) {
                let value:string = stringify(node)
                wordCount++;
                letters += value.length;
            }
        }

        let gradeLevel:number = ariScore.length > 0 ? Math.round(Math.floor((ariScore.reduce((a,b) => a + b)) / ariScore.length)) : 0;

        file.gradeLevel = getGradeText(gradeLevel);
    }

    function getGradeText (age:number){
        switch (age) {
            case (14): return "Professional";
            case (13): return "College student";
            case (12): return "12th grade";
            case (11): return "11th grade";
            case (10): return "10th grade";
            case (9): return "9th grade";
            case (8): return "8th grade";
            case (7): return "7th grade";
            case (6): return "6th grade";
            case (5): return "5th grade";
            case (4): return "4th grade";
            case (3): return "3rd grade";
            case (2): return "2nd grade";
            case (1): return "1st grade";
            default: return "Grade Level not available";
        }
    }
    
    function ari(counts:any){
        let characterWeight:number = 4.71;
        let sentenceWeight:number = 0.5;
        let base:number = 21.43;
    
        if (!counts || !counts.sentence || !counts.word || !counts.character) {
            return NaN;
        };
    
        return (
            characterWeight * (counts.character / counts.word) +
            sentenceWeight * (counts.word / counts.sentence) -
            base
        );
    };
};

